// extracted by mini-css-extract-plugin
module.exports = {"mbn":"Mbn_mbn__1B47e"};